// UAT
// export const domain = 'https://centro-admin.kisrasprint.com/';
// Production
export const domain = 'https://admin.thecentrocondo.com/';